import qs from "qs";
import { SplatProspectResponse } from "providers/Types";

type UsageCalculatorInput = {
  baseUsage?: number;
  yearBuilt?: string;
  utilityCo?: string;
  lat?: number;
  long?: number;
  zip?: string;
  prospectId?: string;
};

const useUsageCalculatorUrl = (
  prospectId?: string,
  usage?: SplatProspectResponse
) => {
  let usageCalculatorBaseUrl = `https://www.usagecalculator.ai.sunrun.com/?`;
  if (!usage || !prospectId) {
    return usageCalculatorBaseUrl;
  }

  const {
    customerZipCode,
    janUsage,
    febUsage,
    marUsage,
    aprUsage,
    mayUsage,
    junUsage,
    julUsage,
    augUsage,
    sepUsage,
    octUsage,
    novUsage,
    decUsage,
    latitude,
    longitude,
    utilityCompany,
    yearBuilt,
  } = usage;

  const anualBaseUsage = [
    janUsage,
    febUsage,
    marUsage,
    aprUsage,
    mayUsage,
    junUsage,
    julUsage,
    augUsage,
    sepUsage,
    octUsage,
    novUsage,
    decUsage,
  ].reduce<number>((sum, val) => sum + (val || 0), 0);

  const usageCalulatorInputs: UsageCalculatorInput = {
    baseUsage: anualBaseUsage,
    yearBuilt,
    utilityCo: utilityCompany,
    lat: latitude,
    long: longitude,
    zip: customerZipCode,
    prospectId,
  };

  return (usageCalculatorBaseUrl += qs.stringify(usageCalulatorInputs));
};

export { useUsageCalculatorUrl };
